export default (builder) =>
  builder.query({
    query: () => ({
      url: '/config/orgs',
      method: 'GET',
    }),
  });
